// @flow
import styled from 'styled-components'
import {Button, Card, Layout} from 'antd'
const { Content } = Layout
export const PortfoliosGridWrapper = styled.div`
  & .panel-heading, .panel-footer {
    background-color: #59a1d4 !important;
  }
  & .dx-g-bs4-toolbar { 
    min-height: unset;
  }
`

export const StyledDiv = styled.div`
  margin: 20px;
  table{
    min-width: 820px !important;
    
  }
  .ant-table-content {
    background: #fff;
  }
`
export const StyledButton = styled(Button)`
  width: 100px;
  display: inline;
  float: left;
  &.active { 
   background: #3183ff;
   color: #fff;
  }
`

export const StyledContent = styled(Content)`
  background: #fff;
  margin: 24px 16px;
  min-height: 280px;
  padding: 0;
`
export const StyledCard = styled(Card) `
  width:100%
  .ant-card-head-title {
    p {
      margin: 0;
      span {
        font-size: 10px;
        float: right;
      }
    }
   }
   .ant-card-body {
    padding: 24px 0;
   }
`




// WEBPACK FOOTER //
// ./src/components/view-positions/style.js